<template>
  <el-select
    v-model="value"
    @change="change"
    filterable
    clearable

    placeholder="请选择DSP广告位">
    <el-option
      v-for="item in slotNameOptions"
      :key="item.dspSlotId"
      :label="item.dspSlotName"
      :value="item.dspSlotId" />
  </el-select>
</template>

<script>
import { getDspApplyName } from '@/api/select'
import {hot} from "@/api/hot"

export default {
  props: {
    modelValue: [String, Number],
    dspId: {
      type: [String, Number],
      default: undefined
    }
  },
  emits: ['update:modelValue', 'change'],
  data () {
    return {
      slotNameOptions: [],
      value: undefined
    }
  },
  watch: {
    dspId () {
      this.value = ''
      this.change('')
      this.getDspApplyName()
    }
  },
  created () {
    this.getDspApplyName()
  },
  methods: {
    getDspApplyName () {
      getDspApplyName({ dspId: this.dspId }).then(res => {
        if (res.code === 200) {
          this.slotNameOptions = res.data
          // this.slotNameOptions.map((item)=>{
          //   item.dspSlotName=item.dspSlotName+"-"+item.dspSlotCode
          // })
        }
      })
    },
    change (item) {
      let data={
        maker:"slotDspOnThe",
        onTheOrderId:item
      }
      if(item){
        hot(data)
      }
      this.$emit('update:modelValue', item)
      this.$emit('change', item)
    },
    // removeBlank(val) {
    //   this.value = val.replace(/^\s+|\s+$/gm, '')
    // }
  }
}
</script>

<style scoped>

</style>
